import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/core';
import { SafeResourceUrl } from '@angular/platform-browser';

@Component({
	selector: 'app-header',
	templateUrl: './Header.component.html',
	styleUrls: ['./Header.component.scss'],
})
export class HeaderComponent implements OnInit {
	private _router: Subscription;
	url: string;

	isFixedClass = false;

	get isUserLogged(): boolean {
		return this.authService.isAuthenticated;
	}

	public logOut = async () => {
		await this.authService.logout();
	};

	get profileAvatar(): SafeResourceUrl {
		return this.authService.getProfileAvatar;
	}

	get profileName(): string {
		return this.authService.getProfileName;
	}

	constructor(private router: Router, private authService: AuthService) { }

	ngOnInit() {}

	isFixedHeader() {
		if (
			this.url === '/listing/half-map/grid' ||
			this.url === '/listing/half-map/list'
		) {
			return true;
		} else {
			return false;
		}
	}
}
